import { Plugin } from '@ckeditor/ckeditor5-core/src';
//import { Typing } from '@ckeditor/ckeditor5-typing/src';

function downcastImageAttribute( imageUtils, imageType, attributeKey, viewAttributeKey ) {
	return dispatcher => {
		dispatcher.on( `attribute:${ attributeKey }:${ imageType }`, converter );
	};

	function converter( evt, data, conversionApi ) {
		if ( !conversionApi.consumable.consume( data.item, evt.name ) ) {
			return;
		}

		const viewWriter = conversionApi.writer;
		const element = conversionApi.mapper.toViewElement( data.item );
		const img = imageUtils.findViewImgElement( element );

		viewWriter.setAttribute( viewAttributeKey, data.attributeNewValue || '', img );
	}
}


/**
 * Converting <code> blocks without required by CKEditor <pre> block. Only needed for content created prior to CKEditor.
 */
export default class ImageWrapper extends Plugin {

    /**
	 * @inheritDoc
	 */
	static get requires() {
		return [ ];
	}

	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'ImageWrapper';
	}

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );
	}

    /**
	 * @inheritDoc
	 */
    init() {

		const editor = this.editor;
		const conversion = editor.conversion;
		const imageUtils = editor.plugins.get( 'ImageUtils' );

		editor.model.schema.extend( 'imageInline', { allowAttributes: 'attachmentPreview' } );

		editor.conversion.for('downcast').add(downcastImageAttribute( imageUtils, 'imageInline', 'attachmentPreview', 'data-ua-attachment-preview' ));

        editor.conversion.for( 'upcast' ).attributeToAttribute( {
            view: {
                name: 'img',
                key: 'data-ua-attachment-preview'
            },
            model: 'attachmentPreview',
            converterPriority: 'low'
        } );

		editor.model.schema.addAttributeCheck( context => {
			
			if ( context.endsWith( 'imageInline' ) ) {
				return true;
			}
		});

		conversion.for( 'downcast' ).add( dispatcher => {
            dispatcher.on( 'insert:imageInline', ( evt, data, conversionApi ) => {

                // Remember to check whether the change has not been consumed yet and consume it.
                if ( conversionApi.consumable.consume( data.item, 'insert' ) ) {
                    return;
                }
                const writer = conversionApi.writer;

				writer.setAttribute('attachmentPreview', 'true', data.item);

                // Remember to stop the event propagation.
                evt.stop();
            } );
        } );
    }
}